import { type ShellNavItemId, type ShellNavNotificationCounts } from './shell-nav.types';

export function formatNotificationBadge(count: number): string | null {
  if (count <= 0) return null;
  return count > 99 ? '99+' : String(count);
}

export function resolveShellNavBadges(
  counts: ShellNavNotificationCounts,
): Readonly<Record<ShellNavItemId, string | null>> {
  return {
    home: formatNotificationBadge(counts.home),
    patients: formatNotificationBadge(counts.patients),
    orders: formatNotificationBadge(counts.orders),
    documents: formatNotificationBadge(counts.documents),
    more: formatNotificationBadge(counts.more),
  };
}
